import { useReleaseFlag } from 'hooks/useReleaseFlags';

export const useWaterLevelEnabled = (): boolean => {
  return useReleaseFlag('river_gauges');
};
